<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("territory", 2) }}
      </div>
      <router-link class="btn-blue" to="territory"
        >{{ $tc("territory", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-lg-6 col-xl-3 ">
            <b-form-group>
              <div class="input-material mt-2">
                <b-form-input
                  id="territoryName"
                  v-model="territoryList.territory_name"
                  placeholder="Territory Name"
                  type="text"
                ></b-form-input>
                <label>Territory Name</label>
              </div>
            </b-form-group>
            <label
              v-if="error.territory_name_error"
              style="color:red !important;"
              >Territory Name is required</label
            >

            <!-- <Tooltip :title="$t(item.tooltip)" /> -->
          </div>

          <div class="col-lg-6 col-xl-3 ">
            <b-form-group>
              <div class="input-material mt-2">
                <b-form-input
                  id="territoryCode"
                  v-model="territoryList.territory_code"
                  placeholder="Territory Code"
                  type="text"
                ></b-form-input>
                <label>Territory Code</label>
              </div>
            </b-form-group>
            <label
              v-if="error.territory_code_error"
              style="color:red !important;"
              >Territory Code is required</label
            >

            <!-- <Tooltip :title="$t(item.tooltip)" /> -->
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center">
            <b-form-checkbox
              v-model="territoryList.territory_is_active"
              class="j-checkbox ml-3 mb-3"
              unchecked-value="N"
              value="Y"
            >
              Is Active
            </b-form-checkbox>
            <!-- <label style="color:red !important;" v-if="error.isActive_error_msg">isActive is required</label> -->
          </div>

          <div class="col-md-12 text-center mt-4">
            <button
              class="btn-blue"
              @click.prevent.stop="onTerritoryFinalSubmit()"
            >
              <!-- @click.prevent.stop="onFinalSubmit(true)" -->
              {{ $t("save") }}
            </button>
            <!-- <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button> -->

            <b-button
              class="btn-outline-grey"
              variant="default"
              to="territory"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import ExhibitorService from "@/services/ExhibitorService";
  const dropdownvalidation = ["country_id"];

  export default {
    data() {
      return {
        territoryData: [],
        editMode: false,
        territoryList: {
          territory_id: "",
          territory_name: "",
          territory_code: "",
          territory_is_active: false,
        },
        error: {
          territory_name_error: false,
          territory_code_error: false,
        },
        btenable: false,
      };
    },
    beforeMount() {
      console.log(this.$route.query, "this.$route.query");
      if (this.$route.query.territory_id) {
        this.editMode = true;
        this.territoryList.territory_id = this.$route.query.territory_id;
        this.getTerritoryData();
      }
    },
    mounted() {},
    methods: {
      validateData() {
        if (!this.territoryList.territory_name) {
          this.error.territory_name_error = true;
          return false;
        } else {
          this.error.territory_name_error = false;
        }

        if (!this.territoryList.territory_code) {
          this.error.territory_code_error = true;
          return false;
        } else {
          this.error.territory_code_error = false;
        }

        // Verification Done!
        return true;
      },

      onTerritoryFinalSubmit() {
        if (this.validateData()) {
          let loader = this.$loading.show();
          let payload = {
            territory_id: this.editMode
              ? this.territoryList.territory_id
              : undefined,
            territory_name: this.territoryList.territory_name,
            territory_code: this.territoryList.territory_code,
            territory_is_active: this.territoryList.territory_is_active,
          };
          //console.log(payload);
          ExhibitorService.AddTerritory(payload)
            .then((response) => {
              const { data } = response;
              this.$toasted.show(data.message);
              this.$router.go(-1);
            })
            .catch((err) => {
              //console.log(err);
            })
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        } else {
          console.error("Validation Error");
        }
      },

      getTerritoryData() {
        // this.pp_type_id = item.pp_type_id;
        // this.is_active = item.is_active;
        let payload = {
          territory_id: this.editMode
            ? this.territoryList.territory_id
            : undefined,
          // is_active: this.is_active,
        };
        ExhibitorService.GetTerritoryData(payload)
          .then((response) => {
            const { data } = response;

            if (data.Records.length > 0) {
              // console.log(data.Records);
              let territoryData = data.Records;
              this.territoryData = territoryData;
              this.territoryList.territory_name = this.territoryData[0].territory_name;
              this.territoryList.territory_code = this.territoryData[0].territory_code;
              this.territoryList.territory_is_active = this.territoryData[0].territory_is_active;
            } else {
              this.territoryData = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TerritoryComponents/addTerritory.vue